import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Box, CircularProgress} from 'views/components';

import WeeklySlip from './WeeklySlip';

const Payment = (props) => {
  const caregiverRn = props.caregiverRn;
  const refresh = props.refresh;
  const caregiverBackend = props.caregiverBackend;
  const caregiverPaymentSlip = props.caregiverPaymentSlip;
  const caregiverPaymentSlipLoading = props.caregiverPaymentSlipLoading;

  React.useEffect(() => {
    caregiverBackend.payment.loadPaymentSlips();
  }, [caregiverRn, refresh]);

  if (caregiverPaymentSlipLoading) {
    return (
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: 2,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Stack
      sx={{
        p: 2,
      }}
      spacing={1}
    >
      {
        Object.values(caregiverPaymentSlip).map((e, index) => {
          return (
            <WeeklySlip
              key={e.weekOf}
              slipDetail={e}
              caregiverBackend={caregiverBackend}
            />
          );
        })
      }
    </Stack>
  );
};

Payment.propTypes = {
  refresh: PropTypes.number.isRequired,
  caregiverRn: PropTypes.string.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
  caregiverPaymentSlip: PropTypes.object.isRequired,
  caregiverPaymentSlipLoading: PropTypes.bool.isRequired,
};
export default React.memo(Payment);
